export default __webpack_public_path__ + "static/media/27.8b610ee9.jpg";